jQuery("[data-whatsapp]").on("click", function () {
  const { itemNumber } = window.Rockrooster || {};
  const data = jQuery(this).data();
  const url = new URL("https://wa.me/" + data.whatsapp);
  if (itemNumber) {
    url.searchParams.set(
      "text",
      "I’d like to inquire about [" + itemNumber + "]. Awaiting your response."
    );
  } else {
    url.searchParams.set(
      "text",
      "I’d like to inquire about something. Awaiting your response."
    );
  }
  window.open(url.toString());
});
jQuery(document).on("mousedown", "[data-auto-trace]", function () {
  const { report } = window.Rockrooster || {};
  const { autoTrace, ...otherProps } = jQuery(this).data();
  if (autoTrace) {
    report(autoTrace, otherProps);
  }
});
jQuery("[data-auto-masonry]").each(function () {
  const element = jQuery(this);
  const { autoMasonry } = element.data();
  element.masonry(autoMasonry);
});
